import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ICommentDefaultMessages, IComments, ICommentsSlice, IReplyToAuthor, IUsersCommentsProfiles } from "../../interfaces/interfaces";

const CommentsSliceState: ICommentsSlice = {
    comments: undefined,
    commentsCount: 0,
    commentsCountPagination: 0,
    selectedEmoji: "",
    replyToAuthor: { author: "", id: 0 },
    realTimeReply: undefined,
    canAddComment: false,
    canShowSubmittedComment: false,
    commentDefaultMessages: [],
    usersCommentsProfiles: []
};

export const commentsSlice = createSlice({
    name: "comments",
    initialState: CommentsSliceState,
    reducers: {
        setComments: (state, action: PayloadAction<IComments[] | undefined>) => {
            state.comments = action.payload;
        },
        setCommentsCount: (state, action: PayloadAction<number>) => {
            state.commentsCount = action.payload;
        },
        setCommentsCountPagination: (state, action: PayloadAction<number>) => {
            state.commentsCountPagination = action.payload;
        },
        setSelectedEmoji: (state, action: PayloadAction<string>) => {
            state.selectedEmoji = action.payload;
        },
        setReplyToAuthor: (state, action: PayloadAction<IReplyToAuthor>) => {
            state.replyToAuthor = action.payload;
        },
        setRealTimeReply: (state, action: PayloadAction<IComments | undefined>) => {
            state.realTimeReply = action.payload;
        },
        setCanAddComment: (state, action: PayloadAction<boolean>) => {
            state.canAddComment = action.payload;
        },
        setCommentDefaultMessages: (state, action: PayloadAction<ICommentDefaultMessages[]>) => {
            state.commentDefaultMessages = action.payload;
        },
        setCanShowSubmittedComment: (state, action: PayloadAction<boolean>) => {
            state.canShowSubmittedComment = action.payload;
        },
        setUsersCommentsProfiles: (state, action: PayloadAction<IUsersCommentsProfiles[]>) => {
            state.usersCommentsProfiles = action.payload;
        },
        setClearCommentsSlice: () => {
            return CommentsSliceState;
        }
    }
});

export const {
    setComments,
    setCommentsCount,
    setCommentsCountPagination,
    setSelectedEmoji,
    setCommentDefaultMessages,
    setReplyToAuthor,
    setRealTimeReply,
    setCanAddComment,
    setCanShowSubmittedComment,
    setUsersCommentsProfiles,
    setClearCommentsSlice
} = commentsSlice.actions;

export default commentsSlice.reducer;
